import "./style.css";

export default class Publication {
  static selector = ".publication";

  constructor(block) {
    this.block = block;
    this.publicationId = parseInt(this.block.dataset.publication, 10);

    this.downloadButton = this.block.querySelector(
      ".publication__gated-download-button"
    );
    this.requestCopyButton = this.block.querySelector(
      ".publication__request-copy-button"
    );
  }

  handleDownloadClick = () => {
    if (!window.App.modals.GatedFileModal) {
      return;
    }

    if (!this.publicationId) {
      return;
    }

    window.App.modals.GatedFileModal.open();
    window.App.modals.GatedFileModal.update({
      publicationId: this.publicationId
    });
  };

  handleRequestCopyClick = () => {
    if (!window.App.modals.RequestCopyModal) {
      return;
    }

    if (!this.publicationId) {
      return;
    }

    window.App.modals.RequestCopyModal.open();
    window.App.modals.RequestCopyModal.update({
      publicationId: this.publicationId
    });
  };

  onReady = () => {
    this.downloadButton?.addEventListener("click", this.handleDownloadClick);
    this.requestCopyButton?.addEventListener(
      "click",
      this.handleRequestCopyClick
    );
  };

  onDestroy = () => {
    this.downloadButton?.removeEventListener("click", this.handleDownloadClick);
    this.requestCopyButton?.removeEventListener(
      "click",
      this.handleRequestCopyClick
    );
  };
}
